module.exports = __webpack_public_path__ + "img/logo-groupama.ab80fe29.svg";